// Admin (de-admin-service) алдааны кодыг хүн ойлгомжтой монгол мессеж рүү буулгана.
// Backend нь ValidationError-ийн message дотроо "error.admin.*" түлхүүр буцаадаг ба
// энэ апп i18n ашигладаггүй тул кодоор нь (DUPLICATE_DOMAIN гэх мэт) буулгана.
// resolveBillingError-той ижил загвар (utils/billing-errors.ts).
const ADMIN_ERROR_MESSAGES: Record<string, string> = {
  DUPLICATE_DOMAIN   : "Энэ домэйн аль хэдийн бүртгэлтэй байна. Өөр домэйн сонгоно уу.",
  DOMAIN_SOFT_DELETED: "Энэ домэйн өмнө бүртгэгдэж, устгагдсан байна. Сэргээх эсвэл өөр домэйн сонгоно уу.",
};

/**
 * HttpHandler-аас шидсэн алдааг (.code / .message бүхий объект) хүн ойлгомжтой
 * монгол мессеж болгож буулгана. Тохирох код байхгүй бол backend-ийн мессеж,
 * түүнийг ч уншигдахааргүй (код/түлхүүр) бол ерөнхий мессеж буцаана.
 */
export function resolveAdminError(e: unknown): string {
  const err = e as { code?: string; message?: string } | undefined;
  const code = err?.code;
  if (code && ADMIN_ERROR_MESSAGES[code]) return ADMIN_ERROR_MESSAGES[code];

  const message = err?.message;
  // Backend нь ихэвчлэн мессеж дотроо кодоо (ALL_CAPS) эсвэл "error.*" түлхүүр
  // дамжуулдаг — эдгээрийг хэрэглэгчид харуулахгүй.
  const looksLikeCode = typeof message === "string" && /^[A-Z0-9_]+$|^error\./.test(message);
  if (message && !looksLikeCode) return message;

  return "Үйлдэл амжилтгүй боллоо. Дахин оролдоно уу.";
}
